// extracted by mini-css-extract-plugin
export var backButton = "_o-1";
export var content = "_o-d";
export var continueButton = "_o-7";
export var continueHint = "_o-8";
export var continueRow = "_o-6";
export var leftInner = "_o-0";
export var shell = "_o-e";
export var sidebarContent = "_o-5";
export var skipButton = "_o-c";
export var spacer = "_o-2";
export var spin = "_o-a";
export var spinner = "_o-9";
export var spinnerOverlay = "_o-b";
export var subtitle = "_o-4";
export var title = "_o-3";